import { googleMapsApiKey } from "../../config/clientsConfig";

export const mapLoaderConfig = {
    id: "google-map-script",
    googleMapsApiKey,
    libraries: ["geometry", "places"], // ✅ include all needed libraries
  };